import React from 'react';
 
const Contact = () => {
   return (
      
      <div>
         <div className="form_title">
            <h1>Contact</h1>
         </div>
         <div className="content">
            <form className="form" action ="MAILTO:toninho.at@gmail.com" method="post" enctype="text/plain" id="contactForm">
               <div className="form_item">
                  <label className="form_label" for="civility">Civilité : </label>
                  <select className="form_input" type="text" id="civility" name="Civilite" required>
                     <option></option>
                     <option value="Madame">Madame</option>
                     <option value="Monsieur">Monsieur</option>
                  </select>
               </div>
               <div className="form_item">
                  <label className="form_label" for="firstname">Nom : </label>
                  <input className="form_input" type="text" placeholder='Nom' id="firstname" name="Nom" required />
               </div>
               <div className="form_item">
                  <label className="form_label" for="email">Adresse mail : </label>
                  <input className="form_input" type="email" placeholder="Email" id="email" name="Email" required/>
               </div>
               <div className="form_item">
                  <label className="form_label" for="topic">Votre question concerne : </label>
                  <select className="form_input" type="text" id="topic" name="Sujet" required>
                     <option></option>
                     <option className="form_input" value="Radio">Radio</option>
                     <option className="form_input" value="Doublage">Doublage</option>
                     <option className="form_input" value="Musique">Musique</option>
                     <option className="form_input" value="Autres">Autres</option>
                  </select>
               </div>
               <div className="form_item">
                  <label className="form_label" for="message">Message : </label>
                  <textarea className="form_input" type="text" placeholder="Message" id="message" name="Message" required/>
               </div>
            
            <div className="form_button">
               <input type="submit" value="Envoyer"/>
            </div>
            </form>
         </div>
         <script src="main.js"></script>
         <footer>
               <small id="licence">
                  <a href="http://www.antonioteixeira.fr" rel="noopener noreferrer" target="_blank"><img src={require('../img/logo.png')} alt={""} />© Copyright 2020 - Le site a été réalisé par Antonio Teixeira.</a>
               </small>	
         </footer>
      </div>
   );
}
 
export default Contact;